module.exports = __webpack_public_path__ + "static/balloons-73b5bd398b196a4a6872764805b8442e.png";